<script setup lang="ts">

import { usePlanetStore } from '@/stores/planetStore.ts'
import { computed } from 'vue'
import { formatShort } from '@/models/formatNumber.ts'
import { usePlayerOreStore } from '@/stores/playerOreStore.ts'
import { useI18n } from 'vue-i18n'
import SimpleProgressBar from '@/components/Elements/ProgressBar/SimpleProgressBar.vue'

const { t } = useI18n()
const planetStore  = usePlanetStore()
const playerOreStore = usePlayerOreStore()

const maxStorage = computed (() => {
  return planetStore.getTotalStorageCapacity()
})

const currentStorage = computed(() => {
  return playerOreStore.getTotalOreCapacity()
})

const percentage = computed (() => {
  let percentage = currentStorage.value / maxStorage.value * 100
  if(percentage > 100) {
    percentage = 100
  }
  return Math.ceil(percentage)
})

const progressColor = 'metal'

</script>

<template>
  <div class="px-10 pt-5 ">
    <div class="flex justify-between mb-1">
      <span class="text-sm font-medium text-metal-300">{{ t('resources.storage.capacity') }}</span>
      <span class="text-sm font-medium text-metal-300">{{ t('resources.storage.max', { amount: formatShort(maxStorage) }) }}</span>
    </div>
    <SimpleProgressBar
      :percentage="percentage"
      :color="progressColor"
      :height="24"
      :text="`${formatShort(currentStorage)} / ${formatShort(maxStorage)} (${percentage}%)`"
    />
  </div>
</template>


<style scoped lang="scss">

</style>